/* eslint-disable no-param-reassign,consistent-return,array-callback-return */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import {
  getPaymentsNewRoute,
  getPaymentsRoute,
  paymentCoverBillsRoute,
  paymentRegisterRoute,
  paymentUncoverBillsRoute,
  paymentUncoverByInvoiceIdsRoute,
  paymentUncoverByTaxInvoiceIdsRoute,
  paymentsSearchRoute,
  transferBalanceRoute,
} from "../../lib/routes/payments";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import Message from "../../components/Message/Message";

const initialState = {
  findPaymentsAccount: null,
  paymentsAccount: [],
  paymentsAccountLoading: rtkRequestStatusCodes.idle,
  paymentsBill: null,
  paymentsBillLoading: rtkRequestStatusCodes.idle,
  payments: null,
  paymentsLoading: rtkRequestStatusCodes.idle,
  paymentsAll: [],
  paymentsAllLoading: rtkRequestStatusCodes.idle,
  paymentConfirmDataResponse: null,
  paymentConfirmLoading: rtkRequestStatusCodes.idle,
  paymentsNotFulledPay: null,
  paymentsNotFulledPayLoading: rtkRequestStatusCodes.idle,
  agreementAmountLeft: 0,
  agreementAmountLeftLoading: rtkRequestStatusCodes.idle,
  transferBalanceLoading: rtkRequestStatusCodes.idle,
};

const fetchPaymentsByAggNotFullPay = createAsyncThunk(
  "payments/fetchPaymentsByAggNotFullPay",
  async ({ agreementId, queryString }) => {
    const url = [
      getPaymentsRoute("payments", "pageable-search", `?agreementId=${agreementId}`),
      queryString,
    ].join("");
    const { data } = await axios(url);
    data.content.map((item) => {
      item.paymentId = item.id;
      item.billId = null;
      item.amountForPaymentGoal = "";
    });
    return data;
  }
);

const fetchPaymentsByAggId = createAsyncThunk(
  "payments/fetchPaymentsByAggId",
  async ({ agreementId, paymentsSearchParams }) => {
    try {
      let dataServices = [];
      // let searchParams = {};
      await Promise.all(
        agreementId.map(async (agg) => {
          if (paymentsSearchParams) {
            paymentsSearchParams.agreementId = agg;
            const { data } = await axios(getPaymentsNewRoute(paymentsSearchParams));
            if (data) {
              dataServices = [...dataServices, ...data.content];
            }
          }

          // const { data } = await axios.get(
          //   [
          //     getPaymentsRoute("payments", "pageable-search", `?agreementId=${agg}`),
          //     queryString,
          //   ].join("")
          // );
        })
      );
      return dataServices;
    } catch (e) {
      Message("Ошибка загрузки данных. Попробуйте позже", e);
    }
  }
);

export const fetchAgreementAmountLeft = createAsyncThunk(
  "payments/fetchAgreementAmountLeft",
  async (agreementId) => {
    try {
      const url = paymentsSearchRoute({
        agreementId,
        paymentLefts: "onlyWithLefts",
      });
      const { data } = await axios.get(url);
      if (Array.isArray(data)) {
        const amount = data.reduce((acc, payment) => {
          const availableAmount = Number(payment.extra.availableAmount);
          if (isNaN(availableAmount)) {
            return 0;
          }
          return acc + availableAmount;
        }, 0);
        return amount;
      }
      return 0;
    } catch (e) {
      Message("Ошибка загрузки данных. Попробуйте позже", e);
    }
  }
);

export const transferBalance = createAsyncThunk(
  "payments/transferBalance",
  async (transferData) => {
    try {
      const { data } = await axios.post(transferBalanceRoute(), transferData);
    } catch (e) {
      Message("Ошибка переноса баланса. Попробуйте позже", e);
    }
  }
);

const fetchPaymentsByBillId = createAsyncThunk(
  "payments/fetchPaymentsByBillId",
  async ({ billId, queryString }) => {
    const url = [
      getPaymentsRoute("payments", "pageable-search", `?billId=${billId}`),
      queryString,
    ].join("");
    const { data } = billId && (await axios(url));
    return data;
  }
);

const fetchPaymentsAll = createAsyncThunk(
  "payments/fetchPaymentsAll",
  async (paymentsSearchParams) => {
    try {
      const url = getPaymentsNewRoute(paymentsSearchParams);
      const { data } = await axios(url);
      return data;
    } catch (e) {
      Message("Ошибка загрузки данных. Попробуйте позже", e);
    }
  }
);

const postBillUnCover = createAsyncThunk(
  "payments/postBillUnCover",
  // eslint-disable-next-line consistent-return
  async (dataForUnCover) => {
    try {
      const response = axios.patch(paymentUncoverBillsRoute(), dataForUnCover);
      const { data } = await response;
      const { status } = await response;
      Message("Отметка оплаты удалена", status);
      return data;
    } catch (e) {
      Message("Ошибка снятия отметки оплаты", e.response?.data?.message);
    }
  }
);

export const paymentUncoverByInvoiceIds = createAsyncThunk(
  "payments/paymentUncoverByInvoiceIds",
  async (invoiceIds) => {
    try {
      const response = axios.patch(paymentUncoverByInvoiceIdsRoute(), { invoiceIds });
      const { data, status } = await response;
      Message("Отметка оплаты удалена", status);
      return data;
    } catch (e) {
      Message("Ошибка снятия отметки оплаты", e.response?.data?.message);
    }
  }
);

export const paymentUncoverByTaxInvoiceIds = createAsyncThunk(
  "payments/paymentUncoverByTaxInvoiceIds",
  async (taxInvoiceIds) => {
    try {
      const response = axios.patch(paymentUncoverByTaxInvoiceIdsRoute(), { taxInvoiceIds });
      const { data, status } = await response;
      Message("Отметка оплаты удалена", status);
      return data;
    } catch (e) {
      Message("Ошибка снятия отметки оплаты", e.response?.data?.message);
    }
  }
);

const postBillCover = createAsyncThunk(
  "payments/postBillCover",
  // eslint-disable-next-line consistent-return
  async (dataForCover) => {
    try {
      const response = axios.post(paymentCoverBillsRoute(), dataForCover);
      const { data } = await response;
      const { status } = await response;
      Message("Отметка оплаты прошла", status);
      return data;
    } catch (e) {
      Message("Ошибка отметки оплаты", e.response?.data?.message);
    }
  }
);

const postRegisterPayment = createAsyncThunk(
  "payments/postRegisterPayment",
  // eslint-disable-next-line consistent-return
  async (dataForRegister, { rejectWithValue }) => {
    try {
      const response = await axios.post(paymentRegisterRoute(), dataForRegister);
      const { data, status } = response;
      Message("Платеж зарегистрирован", status);
      return data;
    } catch (e) {
      Message("Ошибка регистрации платежа", e.response?.data?.message);
      return rejectWithValue(e.response?.data);
    }
  }
);

// REFACTORING Alex убрать это из стора в компонент

const slice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    setAmountForPaymentGoal: {
      reducer: (state, action) => {
        // eslint-disable-next-line no-unused-expressions
        state.findPaymentsAccount =
          state.paymentsNotFulledPay &&
          state.paymentsNotFulledPay.content.find((item) => item.id === action.payload.id);
        state.findPaymentsAccount.amountForPaymentGoal = action.payload.value;
      },
    },
    resetAmountForPaymentGoal: {
      reducer: (state) => {
        state.paymentsNotFulledPay.content = state.paymentsNotFulledPay.content.map((item) => {
          return {
            ...item,
            amountForPaymentGoal: "",
          };
        });
      },
    },
    cleanAgreementAmountLeft: {
      reducer: (state) => {
        state.agreementAmountLeftLoading = rtkRequestStatusCodes.rejected;
        state.agreementAmountLeft = 0;
      },
    },
    resetPaymentsAccount: {
      reducer: (state) => {
        state.paymentsAccountLoading = rtkRequestStatusCodes.idle;
        state.paymentsAccount = [];
      },
    },
  },
  extraReducers: {
    [fetchPaymentsByAggNotFullPay.fulfilled]: (state, { payload }) => {
      state.paymentsNotFulledPay = payload;
      state.paymentsNotFulledPayLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchPaymentsByAggNotFullPay.pending]: (state) => {
      state.paymentsNotFulledPayLoading = rtkRequestStatusCodes.pending;
    },
    [fetchPaymentsByAggId.fulfilled]: (state, { payload }) => {
      state.paymentsAccount = payload;
      state.paymentsAccountLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchPaymentsByAggId.pending]: (state) => {
      state.paymentsAccountLoading = rtkRequestStatusCodes.pending;
    },
    [fetchPaymentsByAggId.rejected]: (state) => {
      state.paymentsAccountLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchPaymentsByBillId.fulfilled]: (state, { payload }) => {
      state.paymentsBill = payload;
      state.paymentsBillLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchPaymentsByBillId.pending]: (state) => {
      state.paymentsBillLoading = rtkRequestStatusCodes.pending;
    },
    [fetchPaymentsAll.fulfilled]: (state, { payload }) => {
      state.paymentsAll = payload;
      state.paymentsAllLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchPaymentsAll.pending]: (state) => {
      state.paymentsAllLoading = rtkRequestStatusCodes.pending;
    },
    [fetchPaymentsAll.rejected]: (state) => {
      state.paymentsAllLoading = rtkRequestStatusCodes.rejected;
    },
    [postBillCover.fulfilled]: (state, { payload }) => {
      state.paymentConfirmDataResponse = payload;
      state.paymentConfirmLoading = rtkRequestStatusCodes.fulfilled;
    },
    [postBillCover.pending]: (state) => {
      state.paymentConfirmLoading = rtkRequestStatusCodes.pending;
    },
    [postBillCover.rejected]: (state, action) => {
      state.paymentConfirmLoading = rtkRequestStatusCodes.rejected;
      Message(action.error.message);
    },
    [fetchAgreementAmountLeft.pending]: (state) => {
      state.agreementAmountLeftLoading = rtkRequestStatusCodes.pending;
    },
    [fetchAgreementAmountLeft.fulfilled]: (state, { payload }) => {
      state.agreementAmountLeft = payload;
      state.agreementAmountLeftLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchAgreementAmountLeft.rejected]: (state) => {
      state.agreementAmountLeftLoading = rtkRequestStatusCodes.rejected;
      state.agreementAmountLeft = 0;
    },
    [transferBalance.pending]: (state) => {
      state.transferBalanceLoading = rtkRequestStatusCodes.pending;
    },
    [transferBalance.fulfilled]: (state) => {
      state.transferBalanceLoading = rtkRequestStatusCodes.fulfilled;
    },
    [transferBalance.rejected]: (state) => {
      state.transferBalanceLoading = rtkRequestStatusCodes.rejected;
    },
  },
});

const { actions, reducer } = slice;
const {
  setAmountForPaymentGoal,
  resetAmountForPaymentGoal,
  cleanAgreementAmountLeft,
  resetPaymentsAccount,
} = actions;
export {
  actions,
  fetchPaymentsByAggId,
  fetchPaymentsByBillId,
  fetchPaymentsAll,
  postBillUnCover,
  postBillCover,
  setAmountForPaymentGoal,
  fetchPaymentsByAggNotFullPay,
  resetAmountForPaymentGoal,
  cleanAgreementAmountLeft,
  postRegisterPayment,
  resetPaymentsAccount,
};
export default reducer;
